export default __webpack_public_path__ + "static/media/profile.2f6d421c.jpeg";